import { render, staticRenderFns } from "./-Tags.vue?vue&type=template&id=390e5b4e&scoped=true&"
import script from "./-Tags.vue?vue&type=script&lang=js&"
export * from "./-Tags.vue?vue&type=script&lang=js&"
import style0 from "./-Tags.vue?vue&type=style&index=0&id=390e5b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e5b4e",
  null
  
)

export default component.exports